import { Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import Modal from "../../../UI/Modal/Modal";
import { useState } from "react";
import { Controller, Path, PathValue, useForm } from "react-hook-form";
import { DocumentCreate } from "../../../../types/api/documents";
import { useNotification } from "../../../../hooks/useNotification";
import { useParams } from "react-router-dom";
import { createNewDocument } from "../../../../api/documentAPI";
import { BASE_IMG_URL } from "../../../../constants/mainAPI";
import TagSelect from "../../../Autocomplete/TagSelect";
import { TagType } from "../../../../types/api/tag";
import CustomSnackbar from "../../../UI/CustomSnackbar";

interface IProps {
    onChange: (val: string | number) => void;
    showTagSelector?: boolean;
    buttonText?: string;
    getDocId?: boolean;
    tagId?: number;
    isDocTagsOnly?: boolean;
}

export const UploadButtonForm = ({
    onChange,
    buttonText = "Добавить файл",
    getDocId,
    showTagSelector,
    tagId,
    isDocTagsOnly,
}: IProps) => {
    const { id } = useParams();
    const [load, setLoad] = useState(false);
    const { handleSubmit, control, setError, reset } = useForm<Pick<DocumentCreate, "file" | "tag_id">>();
    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [showModal, setShowModal] = useState<boolean>(false);
    const closeModal = () => {
        setShowModal(false);
    };
    const upload = (data: Pick<DocumentCreate, "file" | "tag_id">) => {
        createNewDocument(
            id,
            { ...data, format: 0, ...(tagId ? { tag_id: tagId } : {}) },
            data => {
                onChange(getDocId ? data.data.id : `${BASE_IMG_URL}/${data.data.path}`);
                setNotification({
                    severity: "success",
                    message: "Документ добавлен успешно",
                });
                setOpenSnackbar(true);
                setLoad(false);
                reset();
                closeModal();
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoad(false);
                Object.keys(err.errors).forEach((fieldName: any) => {
                    setError(fieldName, {
                        type: "custom",
                        message: err.errors[fieldName][0],
                    });
                });
            },
        );
    };
    const handleClick = () => {
        setShowModal(true);
    };
    return (
        <>
            <Button
                disabled={load}
                variant="outlined"
                onClick={handleClick}
                startIcon={<>{load && <CircularProgress size={"20px"} />}</>}>
                {buttonText}
            </Button>
            <Modal
                open={showModal}
                title={"Загрузка файла"}
                onClose={() => {
                    closeModal();
                }}
                onSubmit={handleSubmit(upload)}>
                <Stack direction="column" gap={1}>
                    <Controller
                        defaultValue={{}}
                        name={`file`}
                        control={control}
                        render={({ field: { onChange, value, ...field }, fieldState }) => (
                            <TextField
                                {...field}
                                size={"small"}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                                label={"Документ"}
                                type={"file"}
                                onChange={(e: any) => {
                                    onChange(e.target.files[0]);
                                }}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                            />
                        )}
                    />
                    {showTagSelector && (
                        <Controller
                            name={`tag_id`}
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value, ...field }, fieldState }) => (
                                <TagSelect
                                    onChange={val => {}}
                                    type={TagType.DOCUMENT}
                                    isDocTagsOnly={isDocTagsOnly}
                                    callbackResult={val => {
                                        onChange(val.id);
                                    }}
                                />
                            )}
                        />
                    )}
                </Stack>
            </Modal>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
        </>
    );
};
